<!-- Pulsante Home immutabile -->
<button
  type="button"
  class="bg-button-secondary flex flex-col gap-1 h-17 items-center justify-center p-4 w-21 shrink-0 cursor-pointer hover:opacity-60 transition-opacity duration-200 active:opacity-60"
  data-testid="home-button"
  [attr.aria-label]="TRANSLATION_KEYS.header.GO_TO_HOMEPAGE | translate"
  [attr.aria-describedby]="'home-button-text'"
  (click)="onHomeClick($event)"
  (keydown.enter)="onHomeClick($event)"
  (keydown.space)="onHomeClick($event)"
>
  <div class="w-7 h-7 flex items-center justify-center">
    <svg-icon
      src="assets/icons/house.svg"
      class="text-button-secondary-text [&>svg]:w-7 [&>svg]:h-7"
      [svgAriaLabel]="''"
    />
  </div>
  <div class="flex items-center justify-center">
    <span
      id="home-button-text"
      class="font-bold text-xs text-button-secondary-text uppercase leading-[10px] underline"
    >
      {{ TRANSLATION_KEYS.header.HOME | translate }}
    </span>
  </div>
</button>
